import React from 'react';
import { useParams } from 'react-router-dom';
import AboutHouse from '../../../../../components/ui/AboutHouse/AboutHouse';
import HouseInfoModal from '../../../../../components/ui/modals/HouseInfoModal/HouseInfoModal';
import useChangeModalVisible from '../../../../../../../hooks/useChangeModalVisible';
import useHouseInfo from '../../../../../queries/useHouseInfo';

const HouseAbout = ({ address }) => {
  const { visible, showModal, hideModal } = useChangeModalVisible();

  const params = useParams();

  const houseId = Number(params.pageId);

  const { data: houseInfo, isFetching: isHouseInfoFetching } = useHouseInfo(
    houseId,
    { staleTime: Infinity }
  );

  return (
    <>
      <AboutHouse
        onChangeButtonClick={showModal}
        data={houseInfo}
        loading={isHouseInfoFetching}
        address={address}
      />
      <HouseInfoModal
        visible={visible}
        onCancel={hideModal}
        houseId={houseId}
        address={
          houseInfo?.city?.fullCity
            ? `${houseInfo.city.fullCity}, ${address}`
            : address
        }
        initialValues={houseInfo}
      />
    </>
  );
};

export default HouseAbout;
